export default {
    approvalFlow: {
        cooperative: {
            delete: 'Elimina Cooperativa',
            deactivate: 'Disattiva Cooperativa',
            activate: 'Attiva Cooperativa',
            add: 'Aggiungi Nuova Cooperativa',
            edit: 'Modifica Cooperativa',
            cooperativeName: 'Nome della Cooperativa',
            cooperativeNameTT: 'Nome della Cooperativa Tooltip',
            membershipPlan: 'Piano di Adesione',
            membershipPlanTT: 'Piano di Adesione Tooltip',
            primaryContact: 'Contatto Principale',
            primaryContactTT: 'Contatto Principale Tooltip',
            firstName: 'Nome',
            lastName: 'Cognome',
            phoneNumber: 'Numero di Telefono',
            email: 'Email',
            location: 'Posizione',
            locationTT: 'Posizione Tooltip',
            country: 'Paese',
            countryTT: 'Paese Tooltip',
            provinceState: 'Provincia/Stato',
            provinceStateTT: 'Provincia/Stato Tooltip',
            regionDistrict: 'Regione/Distretto',
            regionDistrictTT: 'Regione/Distretto Tooltip',
            villageTownCity: 'Villaggio/Città',
            villageTownCityTT: 'Villaggio/Città Tooltip',
            address: 'Indirizzo',
            addressTT: 'Indirizzo Tooltip',
            businessInformation: 'Informazioni Commerciali',
            interestedCommodities: 'Commodity/Prodotti di Interesse',
            interestedCommoditiesTT: 'Commodity/Prodotti di Interesse Tooltip',
            coffee: 'Caffè',
            cacao: 'Cacao',
            landRegistered: 'Quanta terra sarà registrata? (in ettari)',
            userType: 'Tipo di Utente',
            userTypeTT: 'Tipo di Utente Tooltip',
            exporter: 'Esportatore',
            cooperative: 'Cooperativa',
            bothOfThem: 'Entrambi',
            uploadLogo: 'Carica copia del Logo',
            uploadLogoButton: 'CARICA LOGO',
            enterHere: 'Inserisci qui',
            select: 'Seleziona',
            cooperativeNameRequired: 'Il nome della cooperativa è richiesto',
            firstNameRequired: 'Il nome è richiesto',
            emailRequired: 'L\'email è richiesta',
            invalidEmail: 'Email non valida',
            required: 'Richiesto',
            pleaseUploadValidImage: 'Si prega di caricare un file immagine valido',
            errorPreparingData: 'Errore nella preparazione dei dati',
            cancel: 'Annulla',
            save: 'Salva',
            update: 'Aggiorna',

            // List page translations
            listOfCooperatives: 'Elenco delle Cooperative',
            addCooperatives: 'Aggiungi Cooperative',
            loadingData: 'Caricamento dati...',
            search: 'Cerca',
            type: 'Tipo',
            cooperativeTypeInformation: 'Informazioni sul Tipo di Cooperativa',
            all: 'Tutti',
            of: 'di',
            active: 'Attivo',
            unregistered: 'Non Registrato',
            deactivated: 'Disattivato',
            view: 'Visualizza',
            confirmDelete: 'Conferma Eliminazione',
            areYouSureDeleteCooperative: 'Sei sicuro di voler eliminare questa cooperativa?',
            updatedSuccessfully: 'Aggiornato con successo',
            createdSuccessfully: 'Creato con successo',
            errorFetchingCooperativeDetails: 'Errore nel recupero dei dettagli della cooperativa',
            errorSavingCooperative: 'Errore nel salvare la cooperativa',
            errorFetchingCooperativesData: 'Errore nel recupero dei dati delle cooperative',
            cooperativeDeactivatedSuccessfully: 'Cooperativa disattivata con successo',
            errorDeactivatingCooperative: 'Errore nella disattivazione della cooperativa',
            cooperativeDeletedSuccessfully: 'Cooperativa eliminata con successo',
            errorDeletingCooperative: 'Errore nell\'eliminazione della cooperativa',
            // Table headers
            noOfFarms: 'No. di Fattorie',
            cropsProducts: 'Colture/Prodotti',
            status: 'Stato',
            statusTT: 'Stato Tooltip',
            actions: 'Azioni',
            // Cooperative types
            cooperativeAndExporter: 'Cooperativa + Esportatore',
            // Success messages
            cooperativeActivatedSuccessfully: 'Cooperativa attivata con successo',
            back: 'Indietro',
            commoditiesProducts: 'Detail Cooperativa',
            cooperativeEmail: 'Email Cooperativa',
            cooperativePhoneNumber: 'Nomor Telepon Cooperativa',
            logo: 'Logo',
            logoTT: 'Logo Tooltip',
            organization: 'Organizzazione',
            selectOrganization: 'Seleziona Organizzazione',
             dateFrom: 'Data da',
            dateTo: 'Data a',
            registrationDate: 'Data di registrazione',
            downloadFarms: 'Scarica Fattorie',
            noFarmsFound: 'Nessuna fattoria trovata per questa cooperativa.',
            advanced: 'Avanzato',
        },
    },
};
